import StatisticsAPI from '../api/statistics'
import StatisticsHelper from '../helpers/StatisticsHelper'
import SortParams from '../helpers/SortParams'
import moment from 'moment'

const FETCH_DATA = 'FETCH_DATA'
const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS'
const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR'
const TOGGLE_CHECKBOX = 'TOGGLE_CHECKBOX'
const TOGGLE_CHECKBOX_GROUP = 'TOGGLE_CHECKBOX_GROUP'
const SET_AXIS = 'SET_AXIS'
const REMOVE_PARAMETER = 'REMOVE_PARAMETER'
const ADD_PARAMETER = 'ADD_PARAMETER'
const SELECT_PARAMETER = 'SELECT_PARAMETER'
const UNSELECT_PARAMETER = 'UNSELECT_PARAMETER'
const INIT_CHECKBOXES = 'INIT_CHECKBOXES'
const SET_DATE_FROM = 'SET_DATE_FROM'
const SET_DATE_TO = 'SET_DATE_TO'
const SET_STATION_ID = 'SET_STATION_ID'
const SET_TYPES = 'SET_TYPES'
const INIT_METRICS = 'INIT_METRICS'
const EXPORT_START = 'EXPORT_START'
const EXPORT_FINISH = 'EXPORT_FINISH'
const SELECT_TYPE = 'SELECT_TYPE'
const UNSELECT_TYPE = 'UNSELECT_TYPE'

export default {
  namespaced: true,
  state: {
    stationId: null,
    data: null,
    isLoading: false,
    errors: null,
    series: null,
    axis: null,
    dateFrom: null,
    dateTo: null,
    parameters: [],
    checkBoxes: [],
    types: null,
    metrics: null,
    exporting: false,
    selectedType: null
  },
  getters: {
    isLoading (state) {
      return state.isLoading
    },
    exporting (state) {
      return state.exporting
    },
    data (state) {
      return state.data
    },
    checkBoxes (state) {
      return state.checkBoxes
    },
    parameters (state) {
      return state.parameters
    },
    types (state) {
      return state.types
    },
    axis (state) {
      return state.axis
    },
    series (state) {
      return state.series
    },
    dateFrom (state) {
      return state.dateFrom
    },
    dateTo (state) {
      return state.dateTo
    },
    stationId (state) {
      return state.stationId
    },
    metrics (state) {
      return state.metrics
    },
    selectedType (state) {
      return state.selectedType
    }
  },
  mutations: {
    [ FETCH_DATA ] (state) {
      state.isLoading = true
      state.data = null
      state.errors = null
    },
    [ TOGGLE_CHECKBOX ] (state, data) {
      let id = data.id
      let parentId = data.parentId
      let parent = null
      let checkbox = null
      if (parentId !== null) {
        state.checkBoxes.forEach((parentCheckbox) => {
          if (parentCheckbox.id === parentId) {
            parent = parentCheckbox
            parentCheckbox.boxChildrens.forEach((childCheckbox) => {
              if (childCheckbox.id === id) {
                checkbox = childCheckbox
              }
            })
          }
        })
      } else {
        state.checkBoxes.forEach((parentCheckbox) => {
          if (parentCheckbox.id === id) {
            checkbox = parentCheckbox
          }
        })
      }
      checkbox.status = !checkbox.status
      if (checkbox.boxChildrens) { // клик по группе
        let statusAllChildrens = checkbox.status

        checkbox.boxChildrens.forEach(function (elem) {
          elem.status = statusAllChildrens
        })
      } else { // клик по дочерним
        let countChecked = 0
        parent.boxChildrens.forEach(function (ele) {
          if (ele.status) {
            countChecked++
          }
        })

        parent.status = (countChecked === parent.boxChildrens.length)
      }
    },
    [ TOGGLE_CHECKBOX_GROUP ] (state, id) {
      if (state.selectedType === id) {
        state.selectedType = null
      } else {
        state.selectedType = id
      }

      state.checkBoxes.forEach((checkBox) => {
        checkBox.groupShow = checkBox.id === state.selectedType
      })
    },
    [ FETCH_DATA_SUCCESS ] (state, series) {
      state.isLoading = false
      state.errors = null
      if (series.length === 0) {
        state.series = [
          {
            data: [
              [
                moment(state.dateFrom, 'YYYY-MM-DD HH:mm:ss')
                  .valueOf(),
                0
              ],
              [
                moment(state.dateTo, 'YYYY-MM-DD HH:mm:ss')
                  .valueOf(),
                0
              ]
            ]
          }
        ]
      } else {
        state.series = series
      }
    },
    [ FETCH_DATA_ERROR ] (state, errors) {
      state.isLoading = false
      state.series = null
      state.errors = errors
    },
    [ SET_AXIS ] (state, axis) {
      state.axis = axis
    },
    [ REMOVE_PARAMETER ] (state, index) {
      state.parameters.splice(index, 1)
    },
    [ ADD_PARAMETER ] (state) {
      state.parameters.push({
        empty: true
      })
    },
    [ SELECT_PARAMETER ] (state, data) {
      if (state.parameters.find(param => param.id === data.id) === undefined) {
        state.parameters.push(data)
      }
    },
    [ UNSELECT_PARAMETER ] (state, data) {
      state.parameters = state.parameters.filter(p => p.id !== data.id)
    },
    [ INIT_CHECKBOXES ] (state, checkBoxes) {
      state.checkBoxes = checkBoxes
    },
    [ SET_DATE_FROM ] (state, date) {
      state.dateFrom = date
    },
    [ SET_DATE_TO ] (state, date) {
      state.dateTo = date
    },
    [ SET_STATION_ID ] (state, stationId) {
      state.stationId = stationId
    },
    [ SET_TYPES ] (state, types) {
      state.types = types
    },
    [ INIT_METRICS ] (state, metrics) {
      state.metrics = metrics
    },
    [ EXPORT_START ] (state) {
      state.exporting = true
    },
    [ EXPORT_FINISH ] (state) {
      state.exporting = false
    },
    [ SELECT_TYPE ] (state, id) {
      state.selectedType = id
    },
    [ UNSELECT_TYPE ] (state) {
      state.selectedType = null
      state.checkBoxes.forEach((checkBox) => {
        checkBox.groupShow = false
      })
    }
  },
  actions: {
    fetchData ({
      commit,
      getters
    }, interval) {
      if (getters['isLoading']) {
        return null
      }

      commit(FETCH_DATA)
      commit('common/TOGGLE_LOADING_ON', null, { root: true })
      let helper = new StatisticsHelper(getters[ 'checkBoxes' ], getters[ 'parameters' ], getters[ 'metrics' ])
      commit(SET_AXIS, helper.axisConfig())
      StatisticsAPI.fetchData(Number(getters[ 'stationId' ]), {
        'from': getters[ 'dateFrom' ],
        'to': getters[ 'dateTo' ],
        'devices': helper.queryPrameters(),
        'each': interval ? Number(interval) : StatisticsHelper.calculateBatch(getters[ 'dateFrom' ], getters[ 'dateTo' ])
      })
        .then((response) => {
          commit(FETCH_DATA_SUCCESS, helper.getSeries(response.data))
          commit('common/TOGGLE_LOADING_OFF', null, { root: true })
        })
        .catch((error) => {
          commit(FETCH_DATA_ERROR, error)
          commit('common/TOGGLE_LOADING_OFF', null, { root: true })
        })
    },
    async exportData ({
      commit,
      getters
    }) {
      let helper = new StatisticsHelper(getters[ 'checkBoxes' ], getters[ 'parameters' ], getters[ 'metrics' ])

      commit(EXPORT_START)

      let response = await StatisticsAPI.exportData(Number(getters[ 'stationId' ]), {
        'from': getters[ 'dateFrom' ],
        'to': getters[ 'dateTo' ],
        'devices': helper.queryPrameters(),
        'each': StatisticsHelper.calculateBatch(getters[ 'dateFrom' ], getters[ 'dateTo' ])
      })

      commit(EXPORT_FINISH)

      return response.data
    },
    init ({
      commit,
      getters
    }, id) {
      commit(SET_STATION_ID, id)
      StatisticsAPI.fetchDeviceParametersByStation(id)
        .then((response) => {
          let sortParams = new SortParams(response.data)
          commit(SET_TYPES, sortParams.types)
        })
        .catch((error) => {
          commit(FETCH_DATA_ERROR, error)
        })

      StatisticsAPI.fetchDevices(id)
        .then((response) => {
          commit(INIT_CHECKBOXES, StatisticsHelper.formatDevices(response.data))
        })
        .catch((error) => {
          commit(FETCH_DATA_ERROR, error)
        })

      StatisticsAPI.fetchMetrics()
        .then((response) => {
          commit(INIT_METRICS, response.data)
        })
        .catch((error) => {
          commit(FETCH_DATA_ERROR, error)
        })

      let time = moment()
        .subtract(2, 'days')
      commit(SET_DATE_FROM, time.format('YYYY-MM-DD HH:mm:ss'))

      time = moment()
      commit(SET_DATE_TO, time.format('YYYY-MM-DD HH:mm:ss'))
    }
  }
}
